import React from 'react';
import { Select } from 'antd';
import { connect } from 'react-redux';

import { templateListLoad } from "store/models/template";
import { FormItem } from "utils";
import { ListLoadComponent } from 'components/common';


const TemplateSelect = (props) => {
  return (
    <ListLoadComponent
      apiLoad={templateListLoad}
      {...props}
      render={({ items }) => {
        const { onChange, disabled, router, authToken, model, dispatch, activeFilter, ...otherProps } = props;
        return (
          <FormItem {...otherProps}>
            <Select
              style={{ width: '100%' }}
              onChange={onChange}
              showSearch={true}
              optionFilterProp="children"
              filterOption={(input, option) => {
                const children = option.props.children;
                return children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }}
              disabled={disabled}
            >
              {!props.required && <Select.Option value={null}>---</Select.Option>}
              {items.map(item => (
                <Select.Option key={`template${item.id}`} value={item.id}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </FormItem>
        );
      }}
    />
  );
};

const mapState = state => ({
  router: state.router,
  authToken: state.auth.token,
  model: state.template,
});

export default connect(mapState)(TemplateSelect);
